export default {"src":"/_next/static/media/arrow-right.1d1d9e59.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};